<template>
  <el-dialog
    :title="title"
    :visible.sync="dialogVisible"
    width="25%"
    top="2vh"
    append-to-body>
    <div v-loading="contentLoading" class="body" style="height: 500px;overflow-y: scroll;">
      <ul>
        <li v-for="(item,index) of listData" :key="index">
          {{item}}
        </li>
      </ul>
    </div>
  </el-dialog>
</template>

<script>
  const moduleName = "potentialFaults";

  export default {
    data() {
      return {
        dialogVisible: false,
        contentLoading: false,
        id: 0,
        listData: [],
      };
    },
    computed: {
      title() {
        return this.$t("potentialFault.faultOccurrenceTime");
      },
    },
    methods: {
      open(elevatorId, faultCode, beginTime, endTime) {
        this.dialogVisible = true;
        if (elevatorId > 0) {
          this.getData(elevatorId, faultCode, beginTime, endTime);
        }
      },
      getData(elevatorId, faultCode, beginTime, endTime) {
        let params = {
          "elevatorId": elevatorId,
          "faultCode": faultCode,
          "beginTime": beginTime,
          "endTime": endTime,
        };
        this.$api.getData(moduleName + "/faultTimes", params).then(res => {
          this.listData = res.data;
          this.contentLoading = false;
        }).catch((error) => {
          this.contentLoading = false;
          if (error.response) {
            this.$message.error(this.$t("common.tip.getDataError") + error.response.data.message);
          }
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
li {
  list-style-type: none;
}
</style>
